import React from 'react'

import Container from '../../../components/Container'

import t from '../../../translations'
import { Typography } from '@material-ui/core'

const PollIsAlreadyFilled = () => (
  <Container>
    <Typography variant={'body2'}>
      {t.pollView.pollIsAlreadyFilled}
    </Typography>
  </Container>
)

export default PollIsAlreadyFilled
